import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { isObjectEmpty } from 'utility/helpers';
import Question from '../question';
import Answer from '../answer';
import {
  getResponseCountPerQuestion,
  getQuestionAverage,
} from '../../../../utility/reportUtils';

const GridRow = ({
  className,
  translations,
  row,
  reviewComments = [],
  result = {},
  isPercentageView,
  hasPercentageView,
  hasNeutralAnswer,
  hasAverageScore,
  shouldShowQuestionScore = true,
  attributeLayout,
  onViewQuestionComments = () => {},
}) => {
  const responseCountPerQuestion = useMemo(
    () => getResponseCountPerQuestion(result, hasPercentageView),
    [result, hasPercentageView]
  );
  const totalResponses = useMemo(() => {
    if (!result || !hasPercentageView || isObjectEmpty(result)) {
      return 0;
    }
    return responseCountPerQuestion;
  }, [result, hasPercentageView, responseCountPerQuestion]);

  const questionAverage = useMemo(
    () => getQuestionAverage(row, result, responseCountPerQuestion),
    [result, row, responseCountPerQuestion]
  );

  return (
    <div className={className}>
      <Question
        translations={translations}
        question={row}
        hasAverageScore={hasAverageScore}
        shouldShowQuestionScore={shouldShowQuestionScore}
        questionAverage={questionAverage}
        reviewComments={reviewComments}
        onViewQuestionComments={onViewQuestionComments}
      />
      {row.answers.map((answer, index) => (
        <Answer
          key={`row_${row.id}_${answer.id}`}
          attributeLayout={attributeLayout}
          neutralAnswerLabel={translations.neutral.notApplicable}
          isNeutralAnswer={hasNeutralAnswer && index === row.answers.length - 1}
          totalQuestionResponses={totalResponses}
          isPercentageView={isPercentageView}
          answer={answer}
          result={result?.[answer.id]}
        />
      ))}
    </div>
  );
};

GridRow.propTypes = {
  className: PropTypes.string.isRequired,
  hasAverageScore: PropTypes.bool.isRequired,
  shouldShowQuestionScore: PropTypes.bool,
  translations: PropTypes.object.isRequired,
  row: PropTypes.object.isRequired,
  result: PropTypes.shape({}),
  reviewComments: PropTypes.arrayOf(PropTypes.object),
  isPercentageView: PropTypes.bool.isRequired,
  hasPercentageView: PropTypes.bool.isRequired,
  hasNeutralAnswer: PropTypes.bool.isRequired,
  attributeLayout: PropTypes.string.isRequired,
  onViewQuestionComments: PropTypes.func,
};

export default GridRow;
